import { render } from "./html-to-word-practice.vue?vue&type=template&id=5c679806&scoped=true"
import script from "./html-to-word-practice.vue?vue&type=script&lang=js"
export * from "./html-to-word-practice.vue?vue&type=script&lang=js"

import "./html-to-word-practice.vue?vue&type=style&index=0&id=5c679806&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c679806"]])

export default __exports__